// import { mapState } from 'vuex';
import Voucher from '@/components/Voucher/voucher';
import entityCodeEnums from '@/common/js/voucherEntityCode';
import BASE_API from '@/api/dataBase';
import { confirm } from '@/common/js/util';
import loading from '@/common/js/load.js'; //loading
export default {
  components: {
    Voucher,
  },
  data() {
    return {
      activeNameTab: 'first', //新增tab页
      voucherList: [], //凭证列表
      entityDataId: null, //凭证对应单据ID
      voucherIndex: 0, //区分一个页面多种凭证的情况  类似收款单（凭证 代付凭证）
    };
  },
  mounted() {
    this.voucherIndex = 0;
  },
  computed: {},
  methods: {
    // 获取凭证1--判断
    getAccountEntry(extaxData = {}) {
      this.voucherList = [];
      if (Array.isArray(this.voucherFlag)) {
        for (let i = 0; i < this.voucherFlag.length; i++) {
          this.getAccountEntryRequest(this.voucherFlag[i], i, extaxData);
        }
      } else {
        this.getAccountEntryRequest(this.voucherFlag, 0, extaxData);
      }
    },
    // 获取凭证2-调用接口获取数据
    getAccountEntryRequest(voucherFlag, index, extaxData) {
      let entityDataId = this.entityDataId;
      if (voucherFlag == 'AE_AP_BILL') {
        // 解付凭证查询时使用解付ID
        entityDataId = this.baseData.id;
      } else if (voucherFlag == 'AE_AR_ANOTHERPAY_RECEIPTS') {
        // 代付凭证使用代付id
        if (!this.allDetail.anotherPay) return;
        entityDataId = this.allDetail.anotherPay.id;
      }
      if (!entityDataId) return;
      let params = {
        entityDataId: entityDataId,
        entityCode: entityCodeEnums[voucherFlag].entityCode,
        ...extaxData,
      };
      this.$baseRequest.queryAccountEntry(params).then((result) => {
        !index ? (this.voucherList = result) : (this.voucherList1 = result);
        let arr = ['AE_AP_BILL', 'AE_AP_MARGIN_BILL']; // 应付票据-解付 应付票据-解付保证金 已冲销状态不显示
        if (arr.includes(voucherFlag)) {
          this.voucherList = this.voucherList?.filter((item) => item.reverseFlag !== 'Y');
          this.voucherList1 = this.voucherList1?.filter((item) => item.reverseFlag !== 'Y');
        }
      });
    },

    //销售提单和销售退货只做个查询凭证的功能  ladingNo=#提单号或者退货号#,isTh=#0，提单；1退货#
    async queryLadingVouchers(params) {
      let result = await this.$axios.post(BASE_API.QUERY_LADING_VOUCHERS, params);
      if (0 == result.data.code) {
        this.voucherList = result.data.data;
      } else {
        this.alertErr(result.data.msg);
      }
    },

    // 确认弹出框
    doConfirm() {
      this.$refs.voucher.accoutForm.postDate = null;
      this.$refs.voucher.currentDialogAccountFlag = 'doConfirm';
      this.$refs.voucher.dialogAccountVisible = true;
    },

    // 生成凭证弹出框
    handleAccountEntry() {
      this.voucherIndex = 0;
      this.$refs.voucher.currentDialogAccountFlag = 'handleAccountEntry';
      this.$refs.voucher.accoutForm.postDate = null;
      this.$refs.voucher.dialogAccountVisible = true;
    },
    // 生成凭证弹出框 确认
    postInfo(postInfo) {
      const voucherFlag = Array.isArray(this.voucherFlag)
        ? this.voucherFlag[this.voucherIndex]
        : this.voucherFlag;
      let entityDataId = this.entityDataId;
      if (voucherFlag == 'AE_AR_ANOTHERPAY_RECEIPTS') {
        // 收款单 代付
        entityDataId = this.allDetail.anotherPay.id;
      }
      this.$baseRequest
        .genarateVoucher(entityCodeEnums[voucherFlag].interface, {
          id: entityDataId,
          ...postInfo,
        })
        .then((res) => {
          if (res) {
            this.activeNameTab = 'voucherTab';
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            // 调用配置好的回调方法
            this.callbackToGetDetail(voucherFlag);
          }
        });
    },

    // 过账凭证
    doSyncVoucherForEntityData(extaxData = {}) {
      const voucherFlag = Array.isArray(this.voucherFlag)
        ? this.voucherFlag[this.voucherIndex]
        : this.voucherFlag;
      let entityDataId = this.entityDataId;
      let params = {
        entityDataId: entityDataId,
        entityCode: voucherFlag,
        ...extaxData,
      };
      if (voucherFlag == 'AE_AP_BILL') {
        // 解付凭证查询时使用解付ID
        params.entityDataId = this.baseData.id;
      } else if (voucherFlag == 'AE_AP_ACCRUED') {
        // 预提时多传一个参数
        params['eventCode'] = 'AE_AP_ACCRUED';
      }
      loading.startLoading();
      this.$axios
        .post(entityCodeEnums.syncVoucher.url, params)
        .then((res) => {
          loading.endLoading();
          if (res) {
            this.activeNameTab = 'voucherTab';
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            // 调用配置好的回调方法
            this.callbackToGetDetail(voucherFlag);
          }
        })
        .catch(() => {
          loading.endLoading();
        });
    },

    // 冲销凭证--1 判断是否关联结算批次
    async doReverseAccountEntry(extaxData = {}) {
      //撤销前判断是否关联结算批次
      let settleRes = null;
      // 需要判断是否关联结算批次
      if (
        this.checkSettleParams &&
        this.checkSettleParams['associationType'] &&
        this.checkSettleParams['associationNoList']
      ) {
        settleRes = await this.$baseRequest.chkOrderSettle(this.checkSettleParams);
        // 以管理结算批次
        if (settleRes.code == 10000) {
          let msg = '该单据已关联结算批次，是否确认冲销？';
          confirm('确认冲销？', msg)
            .then(async () => {
              this.doReverseAccountEntryDialog(extaxData);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('message.cancelled'),
              });
            });
        } else if (settleRes.code == 0) {
          //未关联结算批次
          this.doReverseAccountEntryDialog(extaxData);
        } else {
          //校验结算批次异常
          this.$message({ showClose: true, type: 'error', message: settleRes.msg });
        }
      } else {
        //不需要判断是否关联结算批次
        this.doReverseAccountEntryDialog(extaxData);
      }
    },

    // 冲销凭证--2 弹框
    doReverseAccountEntryDialog() {
      const voucherFlag = Array.isArray(this.voucherFlag)
        ? this.voucherFlag[this.voucherIndex]
        : this.voucherFlag;
      if (voucherFlag == 'AE_AR_ANOTHERPAY_RECEIPTS') {
        //收款单 代付凭证
        if (!this.allDetail.anotherPay) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '没有代付信息',
          });
          return;
        }
      }
      this.$refs.voucher.dialogFormVisible = true;
    },

    // 填写冲销信息后确认
    reverseInfo(reverseInfo) {
      const voucherFlag = Array.isArray(this.voucherFlag)
        ? this.voucherFlag[this.voucherIndex]
        : this.voucherFlag;
      let entityDataId = this.entityDataId;
      let url = entityCodeEnums.reverseVoucher.url;
      if (voucherFlag == 'AE_AP_BILL') {
        // 解付凭证查询时使用解付ID
        entityDataId = this.baseData.id;
      } else if (voucherFlag == 'AE_AR_ANOTHERPAY_RECEIPTS') {
        // 收款单 代付
        entityDataId = this.allDetail.anotherPay.id;
        url = entityCodeEnums[voucherFlag].reverseVoucher;
      } else {
        if (entityCodeEnums[voucherFlag].reverseVoucher)
          url = entityCodeEnums[voucherFlag].reverseVoucher;
      }
      loading.startLoading();
      this.$axios
        .post(url, {
          entityDataId: entityDataId,
          entityCode: voucherFlag,
          id: entityDataId,
          ...reverseInfo,
        })
        .then((res) => {
          loading.endLoading();
          if (res.data.code == 0) {
            this.activeNameTab = 'voucherTab';
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            // 调用配置好的回调方法
            this.callbackToGetDetail(voucherFlag);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        })
        .catch(() => {
          loading.endLoading();
        });
    },

    // 撤销
    doWithdrawCommon(params) {
      this.$confirmAction('确认撤回', '是否撤回？')
        .then(() => {
          const voucherFlag = Array.isArray(this.voucherFlag)
            ? this.voucherFlag[this.voucherIndex]
            : this.voucherFlag;
          let url = entityCodeEnums[voucherFlag].withdraw;
          this.$axios.post(url, params).then((res) => {
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: '撤回成功' });
              // 调用配置好的回调方法
              this.callbackToGetDetail(voucherFlag);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          });
        })
        .catch(() => {
          this.$message({ showClose: true, type: 'info', message: this.$t('message.cancelled') });
        });
    },

    // 调用回调 查询单据详情
    callbackToGetDetail(voucherFlag) {
      if (entityCodeEnums[voucherFlag].callbackMethod)
        this.$options.methods[entityCodeEnums[voucherFlag].callbackMethod].bind(this)();
    },
  },
};
